import { ref } from 'vue'

export function useViewport() {
  const viewport = ref('desktop')

  const viewportOptions = [
    { value: 'mobile', label: __('Mobile') },
    // Note: The current responsive breakpoint skips the tablet range entirely
    // and goes straight to mobile. Since it isn't possible to see the tablet
    // version, it is hidden as an option for now to avoid confusion.
    // { value: 'tablet', label: __('Tablet') },
    { value: 'desktop', label: __('Desktop') },
  ]

  return {
    viewport,
    viewportOptions,
    setViewport(newViewport) {
      viewport.value = newViewport
    },
    isMobile() {
      return viewport.value === 'mobile'
    },
    isTablet() {
      return viewport.value === 'tablet'
    },
    isDesktop() {
      return viewport.value === 'desktop'
    },
  }
}
